module.exports = __webpack_public_path__ + "static/media/pc-dataVoucherImage.4736478f.png";